/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GenericErrorReportVO } from '../model';
// @ts-ignore
import { LayerErrorReportVO } from '../model';
// @ts-ignore
import * as Objs from './index'
// @ts-ignore
import { DataResponseVO, DataRequestVO, ExportRequestVO } from '@mc/data-filter-react';

/**
 * ErrorReportControllerApi - axios parameter creator
 * @export
 */
export const ErrorReportControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<GenericErrorReportVO>} [genericErrorReportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGenericErrorReport: async (genericErrorReportVO?: Array<GenericErrorReportVO>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/error-report/generic`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(genericErrorReportVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<LayerErrorReportVO>} [layerErrorReportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLayerErrorReport: async (layerErrorReportVO?: Array<LayerErrorReportVO>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/error-report/layer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(layerErrorReportVO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ErrorReportControllerApi - functional programming interface
 * @export
 */
export const ErrorReportControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ErrorReportControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<GenericErrorReportVO>} [genericErrorReportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postGenericErrorReport(genericErrorReportVO?: Array<GenericErrorReportVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.postGenericErrorReport(genericErrorReportVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<LayerErrorReportVO>} [layerErrorReportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postLayerErrorReport(layerErrorReportVO?: Array<LayerErrorReportVO>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {

            const localVarAxiosArgs = await localVarAxiosParamCreator.postLayerErrorReport(layerErrorReportVO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ErrorReportControllerApi - factory interface
 * @export
 */
export const ErrorReportControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ErrorReportControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {Array<GenericErrorReportVO>} [genericErrorReportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postGenericErrorReport(genericErrorReportVO?: Array<GenericErrorReportVO>, options?: any): AxiosPromise<void> {
            return localVarFp.postGenericErrorReport(genericErrorReportVO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<LayerErrorReportVO>} [layerErrorReportVO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLayerErrorReport(layerErrorReportVO?: Array<LayerErrorReportVO>, options?: any): AxiosPromise<void> {
            return localVarFp.postLayerErrorReport(layerErrorReportVO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ErrorReportControllerApi - interface
 * @export
 * @interface ErrorReportControllerApi
 */
export interface ErrorReportControllerApiInterface {
    /**
     * 
     * @param {Array<GenericErrorReportVO>} [genericErrorReportVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorReportControllerApiInterface
     */
    postGenericErrorReport(genericErrorReportVO?: Array<GenericErrorReportVO>, options?: any): AxiosPromise<void>;

    /**
     * 
     * @param {Array<LayerErrorReportVO>} [layerErrorReportVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorReportControllerApiInterface
     */
    postLayerErrorReport(layerErrorReportVO?: Array<LayerErrorReportVO>, options?: any): AxiosPromise<void>;

}

/**
 * ErrorReportControllerApi - object-oriented interface
 * @export
 * @class ErrorReportControllerApi
 * @extends {BaseAPI}
 */
export class ErrorReportControllerApi extends BaseAPI implements ErrorReportControllerApiInterface {
    /**
     * 
     * @param {Array<GenericErrorReportVO>} [genericErrorReportVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorReportControllerApi
     */
    public postGenericErrorReport(genericErrorReportVO?: Array<GenericErrorReportVO>, options?: any) {
        return ErrorReportControllerApiFp(this.configuration).postGenericErrorReport(genericErrorReportVO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<LayerErrorReportVO>} [layerErrorReportVO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ErrorReportControllerApi
     */
    public postLayerErrorReport(layerErrorReportVO?: Array<LayerErrorReportVO>, options?: any) {
        return ErrorReportControllerApiFp(this.configuration).postLayerErrorReport(layerErrorReportVO, options).then((request) => request(this.axios, this.basePath));
    }
}
